<template>
  <div id="app">
    <TheHeader></TheHeader>
    <div id="content">
      <router-view />
    </div>
  </div>
</template>
<script>
import TheHeader from "@/components/Header.vue";
import axios from "axios";
export default {
  components: { TheHeader },
  watch: {
    $route(to) {
      if (to.meta.title) {
        document.title = "Challenge Maritima | " + to.meta.title;
      }
    },
  },
  mounted() {
    if (this.$cookies.isKey("user_session")) {
      this.$store.state.logged = true;
    }
    document.title = "Challenge Maritima 2023 | " + this.$route.name;
    var _this = this;
    axios.get(this.$store.state.base_url + "/courses/get.php").then(function (response) {
      _this.$store.state.list_courses = response.data;
    });
  },
};
</script>
<style lang="scss">
@import "./assets/css/style.scss";
</style>
